<template>
  <hr class="dropdown-divider" />
</template>

<script>
export default {
  name: 'DropdownDivider'
}
</script>

<style lang="sass" scoped>
@import "@/styles/variables.sass"

.dropdown-divider
  background-color: $gabbi-grey-2
</style>
